export enum LiabilityExclusionType {
    PAY_OFF = 'PAY_OFF',
    OMIT = 'OMIT',
}

export const liabilityExclusionTypeDisplay = {
    [LiabilityExclusionType.PAY_OFF]: 'Pay off',
    [LiabilityExclusionType.OMIT]: 'Omit'
};
